<template>

    <div>
        <form ref="form" method="GET">

            <div class="d-flex flex-wrap justify-content-between">

                <div class="">
                    <div class="filter-label">Filter by:</div>
                    <div class="mx--12px d-flex flex-wrap">
                        <FilterSelect
                            v-for="(filter, key) in filters"
                            :key="key"
                            :post-type="postType"
                            :name="key"
                            :options="filter"/>
                        <div class="d-flex flex-wrap align-items-center my-4px">
                            <button class="btn --default mx-12px sm-mx-0 sm-full-width" @click="submit">Apply</button>
                        </div>
                    </div>
                    <div class="mt-1 sm-my-2">
                        <a :href="$root.resetLink" class="underline c-white defer">Reset filter</a>
                    </div>
                </div><!-- END FILTERS -->

                <div class="f1 d-flex justify-content-end pl-3 sm-pl-0 sm-mt-1 max-width">
                    <div class="max-width">
                        <div class="filter-label">Search:</div>
                        <div class="position-relative">
                            <input
                                type="text"
                                name="search_term"
                                id="search_term"
                                class="input-text input-text--search my-4px"
                                placeholder="Keyword"
                                v-model="search">
                            <input type="hidden" name="onpage" id="onpage" v-model="paged">
                            <button type="submit" class="search-button-overlay"></button>
                        </div>
                    </div>
                </div><!-- END SEARCH -->

            </div>

        </form>
    </div>

</template>

<script>

    import FilterSelect from '@/components/filters/partials/Select';
    import {mapActions} from 'vuex';

    export default {
        name: 'FilterForm',
        components: {FilterSelect},

        props: {
            postType: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                queryString: '',
                pageInit: true
            }
        },

        computed: {
            filters() {
                let filters = this.$store.getters[`Taxonomies/filters`](this.postType);
                console.log(filters);
                return filters;
            },
            formGetter() {
                return this.$store.getters[`Forms/form`](this.postType);
            },
            search: {
                set(value) {
                    this.updateFormValue({postType: this.postType, key: 'search_term', value, filter: false});
                },
                get() {
                    return this.formGetter.search_term;
                }
            },
            paged: {
                set(value) {
                    this.updateFormValue({postType: this.postType, key: 'paged', value, filter: false});
                },
                get() {
                    return this.formGetter.paged;
                }
            },
            hasFilters() {
                return this.$store.getters['Forms/hasFilters'](this.postType);
            },
        },

        watch: {
            /** Don't update on the page load */
            paged() {
                if (this.pageInit) {
                    this.$nextTick(function() {
                        this.submit();
                    });
                } else {
                    this.pageInit = true;
                }
            }
        },

        created() {
            this.loadQueryParameters();
        },

        methods: {
            ...mapActions('Forms', ['updateFormValue']),
            loadQueryParameters() {
                let urlParams = new URLSearchParams(window.location.search);
                for(let key of urlParams.keys()) {
                    if (this.formGetter.filters.hasOwnProperty(key)) {
                        this.updateFormValue(
                            {postType: this.postType, key, value: urlParams.get(key), filter: true}
                        );
                    } else if (this.formGetter.hasOwnProperty(key)) {
                        this.updateFormValue(
                            {postType: this.postType, key, value: urlParams.get(key), filter: false}
                        );
                    }
                }
            },

            /** Actions */
            submit() {
                this.$refs.form.submit()
            }
        }
    }

</script>
